import { Observable } from "rxjs";
import { Pagos } from "../entity/pagos.model";
import { Recaudo } from "../entity/recaudo.model";

export abstract class PagosGateway {

    abstract consultarPagos(codigoTipoDocumento: string, numeroDocumento: string): Observable<Pagos>;

    abstract realizarPago(recaudo: Recaudo): Observable<Boolean>

}